import { TableFooter, TablePagination, TableRow } from "@mui/material";

export default function TabFooter({ data, handleChangePage, handleChangeRowsPerPage, TablePaginationActions, rowsPerPage, page }) {

    return (
        <TableFooter>
            {data.headers &&
                <TableRow>
                    <TablePagination
                        rowsPerPageOptions={[6, 12, 18]}
                        count={data.total}
                        rowsPerPage={rowsPerPage}
                        page={page - 1}
                        labelRowsPerPage='Linhas'
                        SelectProps={{
                            inputProps: { 'aria-label': 'rows per page' },
                            native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                    />
                </TableRow>
            }
        </TableFooter>
    )
}